import { FinancialType } from '../types';

export type EditableFinancialLine = {
  key: string;
  type: FinancialType;
  amount: string;
  description: string;
};

export type LineTotals = {
  invoice: number;
  cash: number;
  total: number;
};

export function createEmptyLine(
  type: FinancialType = 'INVOICE',
): EditableFinancialLine {
  return {
    key: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    type,
    amount: '',
    description: '',
  };
}

export function parseAmountInput(value: string): number {
  const normalized = value.replace(/\s/g, '').replace(',', '.');
  if (!normalized) return 0;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : NaN;
}

export function sumEditableLines(lines: EditableFinancialLine[]): LineTotals {
  let invoice = 0;
  let cash = 0;

  for (const line of lines) {
    const amount = parseAmountInput(line.amount);
    if (!Number.isFinite(amount) || amount <= 0) continue;
    if (line.type === 'INVOICE') invoice += amount;
    else cash += amount;
  }

  return {
    invoice,
    cash,
    total: invoice + cash,
  };
}

/** Display-only totals — backend remains authoritative for persisted values. */
export function amountToApiString(value: string): string {
  const amount = parseAmountInput(value);
  return amount.toFixed(2);
}
